import React from 'react';

import FieldError from 'components/fieldError/fieldError';
import PropTypes from 'prop-types';

import { Select } from '@hotmart/club-custom-components/dist/esm/components/select';

const SelectWrapper = (props) => {
  const hasError = props.hasError || (props.error?.required && props.submitted);

  return (
    <>
      <Select {...props} />
      {hasError && <FieldError error="required" />}
    </>
  );
};

SelectWrapper.propTypes = {
  hasError: PropTypes.bool,
  error: PropTypes.object,
  submitted: PropTypes.bool
};

SelectWrapper.Toggle = Select.Toggle;

export default SelectWrapper;
